var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("stat-layout-card", {
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _c("h2", { staticClass: "m-0" }, [_vm._v(_vm._s(_vm.data.title))])
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return _vm._l(_vm.data.slots, function(stat, statIndex) {
            return _c("div", { key: statIndex, staticClass: "stats-block" }, [
              _c(
                "a",
                {
                  staticClass: "primary-50-hover cpointer gray-100",
                  attrs: { href: stat.link, target: "_blank" }
                },
                [
                  _c("h3", { staticClass: "stats-title" }, [
                    _vm._v(_vm._s(stat.label))
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.dataToDisplay(stat.slots), function(
                    value,
                    valueIndex
                  ) {
                    return _c(
                      "div",
                      {
                        key: valueIndex,
                        staticClass: "data-block-number inline-block"
                      },
                      [
                        _c("h3", { staticClass: "data-value" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                value.type == "amount"
                                  ? _vm.$filters.numberFormat(value.value)
                                  : value.value
                              ) +
                              "\n                        " +
                              _vm._s(value.unit ? value.unit : "") +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "data-label" }, [
                          _vm._v(_vm._s(value.label))
                        ])
                      ]
                    )
                  })
                ],
                2
              )
            ])
          })
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }